import React from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import { ButtonDouble } from "../../../../widget/common/form/Button";
import { FollowingListContextImport } from "../../../../provider/notices/following_list/FollowingListContextProvider";

const FollowingListButtons = (props: { type?: number | undefined }) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const {
    followingBranchList,
    deleteStatus,
    toggleClickDelete,
    submitDeleteConfirm,
  } = FollowingListContextImport();

  return (
    <div style={{ width: type === 3 ? 420 : `100%` }}>
      {followingBranchList != null && deleteStatus && (
        <ButtonDouble
          title1="cancel"
          title2="submit"
          handleClick1={() => toggleClickDelete()}
          handleClick2={() => submitDeleteConfirm()}
        />
      )}
    </div>
  );
};

export default FollowingListButtons;
